var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"frame",attrs:{"src":_vm.getUrl(_vm.media),"title":"Advertisement"},on:{"load":_vm.onLoad,"error":_vm.error}})}
var staticRenderFns = []

export { render, staticRenderFns }